import './globals'
import log from '../logger/log.js';
import { readonly, reactive, ref } from 'vue'
import SockJS from 'sockjs-client';
import Taxi from './Taxi';
import Zone from './Zone';

class Events
{
  constructor(taxis, zones, vars)
  {
    this.taxis = taxis;
    this.zones = zones;
    this.vars = vars;

    this.auth = null;
    this.url = null;
    this.sock = null;
    this.reconnect = true;
    this.authenticated = false;
  }

  send(action_dict)
  {
    if (this.sock !== null && this.sock.readyState === SockJS.OPEN)
    {
      var json = JSON.stringify(action_dict);
      //log.d('protocol.send', json);
      this.sock.send(json);
      return true;
    }
    return false;
  };

  close()
  {
    if (this.sock)
    {
      this.sock.close();
      this.sock = null;
      this.reconnect = false;
      this.authenticated = false;
    }
  };

  set_auth(auth)
  {
    this.auth = auth;
  }

  set_url(url)
  {
    this.url = url.replace(/\/+$/g, '');
  }

  connect()
  {
    this.close();
    this.reconnect = true;
    this.sock = new SockJS(this.url);
    this.sock.onopen = this.onopen.bind(this);
    this.sock.onmessage = this.onmessage.bind(this);
    this.sock.onclose = this.onclose.bind(this);
  }

  onopen()
  {
    //log.d('sock.open');
    let action_dict = {};
    action_dict.action = "LOGIN";
    action_dict.user_agent = navigator.userAgent || "";
    if ("taxi_token" in this.auth)
    {
      action_dict.taxi_token = this.auth.taxi_token;
    }
    else if ("dispatcher_token" in this.auth)
    {
      action_dict.dispatcher_token = this.auth.dispatcher_token;
    }
    else if ("order_short_id" in this.auth)
    {
      action_dict.order_short_id = this.auth.order_short_id;
      action_dict.secret = this.auth.secret;
      action_dict.user_agent = navigator.userAgent || "";
    }
    this.send(action_dict);
  }

  onmessage(e)
  {
    //log.d('sock.message', e);
    //log.d('sock.message', e.data.length);
    if (e.data.trim() !== "")
    {
      this.parse(e.data);
    }
  }

  onclose()
  {
    //log.d('sock.close', this);
    if (this.reconnect)
    {
      //log.d("reconnect");
      setTimeout(this.connect.bind(this)
        , 5000);
      //log.d('sock.close reconnect');
      this.close();
    }
  };

  parse(packet)
  {
    //log.d("protocol.parse", packet);
    let packet_dict = JSON.parse(packet);
    let event = packet_dict.event;
    if (event === "PING")
    {
      //log.d("PING");
      let resp_dict = {};
      resp_dict.action = "PING";
      this.send(resp_dict);
      return;
    }

    if (event === "TAXI")
    {
      let taxi = packet_dict.taxi;
      let taxi_old = null;
      taxi_old = this.taxis[taxi.call_number];
      //log.d('Events old taxi', taxi_old);

      if (taxi_old === undefined)
      {
        taxi_old = new Taxi(taxi.call_number);
        taxi_old.id = taxi.id;
        this.taxis[taxi.call_number] = taxi_old;
        //log.d('Events created taxi', taxi_old);
      }

      taxi_old.lat = taxi.lat;
      taxi_old.lng = taxi.lng;
      taxi_old.acc = taxi.acc;
      taxi_old.address = taxi.address;
      taxi_old.connected = taxi.connected;
      taxi_old.zone = taxi.zone;
      taxi_old.position = taxi.position;

      if('zone_all_position' in taxi)
      {
        taxi_old.zone_all_position = taxi.zone_all_position;
      }

      taxi_old.state = taxi.state;
      taxi_old.state_eta = taxi.state_eta;
      taxi_old.state_zone = taxi.state_zone;
      taxi_old.state_nav_point = taxi.state_nav_point;
      taxi_old.order_ack = taxi.order_ack;
      taxi_old.taxi_group_id = taxi.taxi_group_id;

      if ('duty' in taxi)
      {
        taxi_old.duty = taxi.duty;
      }

      if ('alarm' in taxi)
      {
        taxi_old.alarm = taxi.alarm;
      }

      if ('phone' in taxi)
      {
        taxi_old.phone = taxi.phone;
      }

      if ('free_in_zone' in taxi)
      {
        taxi_old.free_in_zone = taxi.free_in_zone;
      }

      if ('zone_all_count' in taxi)
      {
        taxi_old.zone_all_count = taxi.zone_all_count;
      }

      if ('state_order_id' in taxi)
      {
        taxi_old.state_order_id = taxi.state_order_id;
      }

      if ('current_driver' in taxi)
      {
        taxi_old.current_driver = taxi.current_driver;
      }

      if ('active' in taxi)
      {
        taxi_old.active = taxi.active;
      }

      if ('vehicle_registration' in taxi)
      {
        taxi_old.vehicle_registration = taxi.vehicle_registration;
      }

      if ('brand' in taxi)
      {
        taxi_old.brand = taxi.brand;
      }

      if ('color' in taxi)
      {
        taxi_old.color = taxi.color;
      }

      if ('side_number' in taxi)
      {
        taxi_old.side_number = taxi.side_number;
      }

      //log.d("Events updated taxi", taxi, taxi_old);
      return;
    }

    if (event === "ZONE")
    {
      let zone = packet_dict.zone;
      let zone_old = null;
      zone_old = this.zones[zone.name];
      //log.d('Events old zone', zone_old);

      if (zone_old === undefined)
      {
        zone_old = new Zone(zone.name);
        zone_old.id = zone.id;
        this.zones[zone.name] = zone_old;
        //log.d('Events created zone', zone_old);
      }

      zone_old.id = zone.id;
      zone_old.name = zone.name;
      zone_old.description = zone.description;
      zone_old.not_urban = zone.not_urban;
      zone_old.taxi_group_id = zone.taxi_group_id;

      zone_old.taxi_list = zone.taxi_list;

      //log.d("Events updated zone", zone, zone_old);
      return;
    }

    if (event === "LOGIN")
    {
      if (packet_dict.error)
      {
        log.e("Events LOGIN ERROR", packet_dict.error_data);
        this.reconnect = false;
        return;
      }
      log.d("Events LOGIN OK" , packet_dict.vars);
      this.reconnect = true;
      this.authenticated = true;
      if('vars' in packet_dict)
      {
        if('taxi_zone_all_visible' in packet_dict.vars)
        {
          this.vars.taxi_zone_all_visible = packet_dict.vars.taxi_zone_all_visible;
        }
        if('taxi_group_id' in packet_dict)
        {
          this.vars.taxi_group_id = packet_dict.vars.taxi_group_id;
        }
      }
      return;
    }

  }

}

const taxis = reactive({});
const taxis_ro = readonly(taxis);
const zones = reactive({});
const zones_ro = readonly(zones);
const vars = reactive({
  taxi_zone_all_visible: true,
  taxi_group_id: null,
});
const vars_ro = readonly(vars);
const events = new Events(taxis, zones, vars);

const useEvents = function()
{
  return {
    taxis: taxis_ro,
    zones: zones_ro,
    events_data:
    {
      taxis: taxis_ro,
      zones: zones_ro,
      vars: vars_ro,
    },
    events
  };
}

export { useEvents };
